import Image from 'next/image';
import Link from 'next/link';
import {useRouter} from 'next/router';

import {SEARCH_TYPE} from '@/src/app/constants/search';
import useRoutePaths from '@/src/hooks/useRoutePaths';
import {useTheme} from '@/src/hooks/useTheme';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Text} from '../../ui';
import css from '../styles/EmptySearchResults.module.css';

const EmptySearchResults = () => {
  const {DISCOVER} = useRoutePaths();
  const {isDarkMode} = useTheme();

  const {
    query: {slug},
  } = useRouter();

  return (
    <div className={css.emptyResults}>
      <Image
        src={
          isDarkMode
            ? `/icons/emptyResultsIconDark.svg`
            : `/icons/emptyResultsIcon.svg`
        }
        width="110"
        height="108"
      />
      {slug === SEARCH_TYPE.ALL_CANDIDATES ? (
        <div className={css.emptyResultsInfoAllCandidates}>
          <Text
            color={Text.COLOR.GREY}
            fontWeight={Text.FONT_WEIGHT.THIN}
            fontSize={Text.FONT_SIZE.SIZE_16}
            lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_24}
          >
            <TextLocal id={'search.we-cant-find-any-results'} />
            <br />
            <TextLocal id={'search.try-to-change-filters'} />
          </Text>
        </div>
      ) : (
        <div className={css.emptyResultsInfo}>
          <Text color={Text.COLOR.GREY}>
            <TextLocal id={'search.empty-state-title'} />
            <br />
            <TextLocal id={'search.empty-state-info'} />
            <br />
            <br />
            <TextLocal id={'search.empty-state-return'} />
            <Link href={DISCOVER.getLink()}>
              <a>
                <Text
                  color={Text.COLOR.GRADIENT}
                  display={Text.DISPLAY.INLINE}
                  fontWeight={Text.FONT_WEIGHT.MEDIUM}
                  lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
                >
                  {' '}
                  <TextLocal id={'search.empty-state-discover'} />
                </Text>
              </a>
            </Link>
          </Text>
        </div>
      )}
    </div>
  );
};

export default EmptySearchResults;
